export default __webpack_public_path__ + "static/media/aka-clouds-new.85e84617.webm";